module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"Dashboard","drone.search.input.label":"S/N","drone.search.input.placeholder":"ระบุ S/N ของ Drone","drone.ticket.create.btn":"สร้าง Ticket ใหม่","drone.service.create.btn":"สร้างใบซ่อมใหม่"}}')
  delete Component.options._Ctor
}
